"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACCUMULATION_BUCKET_EXPECTATIONS = void 0;
exports.getAccumulationBucket = getAccumulationBucket;
const browser_1 = require("encamp-prisma/generated/browser");
const stateWasteCodeNormalization_1 = require("encamp-shared/dist/waste/stateWasteCodeNormalization");
const facilityState_1 = require("../facilityState");
const stateAcuteWasteCodes_1 = require("./stateAcuteWasteCodes");
/**
 * Which side of a limit's acute / non-acute split a container counts toward.
 * Separate from the jurisdiction rules on purpose: those answer what the
 * limits are, for hazardous waste; this answers which of them a given
 * container's waste fills. `expectations.ts` is its specification.
 */
function getAccumulationBucket(query) {
    if (heldAcuteByState(query)) {
        return "ACUTE";
    }
    switch (query.classification) {
        case browser_1.WasteClassification.RCRA_ACUTELY_HAZARDOUS:
            return "ACUTE";
        case browser_1.WasteClassification.NONHAZARDOUS:
            return "EXCLUDED";
        case browser_1.WasteClassification.STATE_REGULATED:
            // Pending the waste team's answer on what STATE_REGULATED means per
            // state: the caps count it conservatively, the on-site threshold
            // treats it as outside federal hazardous waste.
            return query.whichThreshold === "SATELLITE_CAPS" ? "NON_ACUTE" : "EXCLUDED";
        case browser_1.WasteClassification.RCRA_HAZARDOUS:
        case null:
            // An unclassified container counts non-acute: acute would trip the
            // 1-quart limit on every drum awaiting characterization.
            return "NON_ACUTE";
    }
}
function heldAcuteByState(query) {
    const state = (0, facilityState_1.parseFacilityState)(query.state);
    const acuteCodes = state === null ? [] : (stateAcuteWasteCodes_1.STATE_ACUTE_WASTE_CODES[state]?.codes ?? []);
    return query.stateWasteCodes.some((code) => {
        const normalized = (0, stateWasteCodeNormalization_1.normalizeStateWasteCode)(code)?.toUpperCase();
        return normalized !== undefined && acuteCodes.includes(normalized);
    });
}
var expectations_1 = require("./expectations");
Object.defineProperty(exports, "ACCUMULATION_BUCKET_EXPECTATIONS", { enumerable: true, get: function () { return expectations_1.ACCUMULATION_BUCKET_EXPECTATIONS; } });
//# sourceMappingURL=index.js.map